export default __webpack_public_path__ + "static/185-fd886db5463acb86c5a1348dd0ad6d01.jpg";